<main>
  <header>
    <h1>Thank You, {{ firstOwner.firstName }} {{ firstOwner.lastName }}!</h1>
    <h2>We've received your application and we are reviewing it. We'll send you a decision to your email, {{ firstOwner.emailAddress }}, as soon as possible. If you have any questions, feel free to contact us at <a href="mailto:support@transendfinancial.com">support&#64;transendfinancial.com</a></h2>
  </header>
</main>
